import { openUrl } from "@/bridge/openUrl";
import { verifyNumber } from "@/bridge/verifyNumber";
import { CheckBox } from "@/components/CheckBox/CheckBox";
import { LoadingOverlay } from "@/components/LoadingOverlay";
import { PersistentData } from "@/helpers/PersistentData";
// import { faCircleRight } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
// import { SIGNED_IN_ROUTES } from "@skillscratch/shared-types";
// import { useSignedInNavigation } from "@/hooks/useSignedInNavigation";
import { usePhoneNumberInput } from "@/hooks/usePhoneNumberInput";
import { Button } from "@/components/ui/button";
import { ClickableLink } from "@/components/ClickableLink/ClickableLink";
import { SafePaddingContainer } from "@/components/SafePaddingContainer";
import { useViewTransition } from "@/hooks/useViewTransition";
import { useSwipeDetection } from "@/hooks/useSwipeDetection";


// import { useIsLocationAllowed } from "@/hooks/useIsLocationAllowed";

export function LoginPage() {
  // const { navigateToSignedInPage } = useSignedInNavigation();

  // const [firstName, setFirstName] = useState("");
  // const [lastName, setLastName] = useState("");

  const [confirm18, setConfirm18] = useState(true);
  const [confirmTerms, setConfirmTerms] = useState(true);

  // const [isProceedDisabled, setIsProceedDisabled] = useState(true);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const { phoneNumber, phoneError, handlePhoneChange, getFirebasePhoneNumber } = usePhoneNumberInput('');

  const { navigateBack, navigateNormal } = useViewTransition(); 
  
  const handleBack = () => {
    navigateBack();
  };

  useSwipeDetection({
    minSwipeDistance: 50,
    onSwipeRight: () => {
      handleBack();
    }
  });


    // const [isLocationAllowed] =
    //   useIsLocationAllowed();

  // useEffect(() => {
  //   setIsProceedDisabled(!(confirm18 && confirmTerms));
  // }, [confirm18, confirmTerms]);

  // useEffect(() => {
  //   (async () => {
  //     const { firstName, phoneNumber } = await PersistentData.getMultiple([
  //       "firstName",
  //       "phoneNumber",
  //     ]);

  //     if (firstName?.trim()) {
  //       setFirstName(firstName);
  //     }
      
  //     if (phoneNumber?.trim()) {
  //       // setPhoneNumber(parsePhoneNumberWithError(phoneNumber).formatInternational());
  //     }
  //   })();
  // }, []);


  return (
    <div className="flex flex-col h-screen overflow-y-scroll pb-40 bg-blue-dark">
      <SafePaddingContainer orientation="header" className="bg-blue-dark h-full">
        <h2 className="text-3xl font-bold text-white">
            Login
        </h2>

        <div className="mb-4">
            <label className="block text-blue-dark mb-2">Full Legal Name</label>

            <input
                type="tel"
                value={phoneNumber}
                onChange={handlePhoneChange}
                className={`w-full text-blue-dark h-12 border ${phoneError ? 'border-red-500' : 'border-slate-300'} rounded px-3 py-2 font-semibold focus:outline-none focus:border-transparent focus:ring-1 focus:ring-slate-400 text-xl`}
                placeholder="+1 (555) 123-4567"
            />
        </div>
        


        <div id="recaptcha-invisible"/>
        <Button
        //   icon={faCircleRight}
        className='h-14 bg-blue text-white text-2xl font-bold w-full rounded-sm'
        onClick={async () => {
        
            if (confirm18 && confirmTerms && phoneNumber && !phoneError) {
            setIsLoading(true);
        
            (async () => {
                let verificationId: string | true;
        
                const standardPhoneNumber = getFirebasePhoneNumber();
                
                if (!standardPhoneNumber) {
                //   setShowError(true);
                //   setErrorMessage("Invalid phone number.");
                  return;
                }
        
                try {
                  verificationId = await verifyNumber(standardPhoneNumber);
                } catch (error) {
                  console.error("Error during number verification:", error);
                  console.log('[number]', standardPhoneNumber);
                  // should probably show an error/handle with sentry/post
                  setShowError(true);
                  setErrorMessage(
                    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
                    (error as any).message ?? "An error occurred."
                  );
                  return;
                }
        
                // if (verificationId === true) {
                //     // verificationId = undefined;
                //     // no-op
                //     return true;
                // }
        
                try {
                  PersistentData.setMultiple({
                    phoneNumber,
                    verificationId: verificationId as string,
                  });
        
                  navigateNormal('/onboarding/page3',
                      {
                          replace: false,
                          viewTransition: true,
                      }
                  );
                } catch (error) {
                console.error("Error during data storage or navigation:", error);
                // should probably show an error/handle with sentry/post
                  setShowError(true);
                  setErrorMessage("An error occurred. Please try again.");
                }
            })().finally(() => {
                setIsLoading(false);
            });
            } else {
              setShowError(true);
            }
        }}
        // disabled={isProceedDisabled}
        //   fillWidth
        >
            Login
        </Button>
        {phoneError && (
            <p className="text-red-500 text-sm mt-2">{phoneError}</p>
        )}

        {showError && errorMessage && (
            <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
        )}

        <div
            style={{
            display: "grid",
            gap: "3vw",
            }}
            className='mt-10'
        >
            <CheckBox
            checked={confirm18}
            onChange={setConfirm18}
            text={
                <span className='text-white font-semibold'>I am 18+ years old</span>
            }
            />
            <CheckBox
            checked={confirmTerms}
            onChange={setConfirmTerms}
            text={
                <span className='text-white font-semibold'>
                I agree to the{" "}
                <ClickableLink
                    text="Terms of Use"
                    onClick={() => {
                    openUrl("https://skillscratch.com/legal/terms");
                    }}
                />
                {", "}
                <ClickableLink
                    text="Prelicensing Agreement"
                    onClick={() => {
                    openUrl("https://skillscratch.com/legal/licensing");
                    }}
                />
                {", "}
                and{" "}
                <ClickableLink
                    text="Privacy Policy"
                    onClick={() => {
                    openUrl("https://skillscratch.com/legal/privacy");
                    }}
                />
                </span>
            }
            />
        </div>
        {isLoading && <LoadingOverlay />}
        </SafePaddingContainer>
    </div>
  );
}